

































import { Component, Vue, Prop, Watch } from "vue-property-decorator";

@Component({
  components: {}
})
export default class ia_agent_type_selector extends Vue {
  @Prop({ type: Boolean, required: true }) public value!: boolean;

  public show: boolean = false;

  created() {
    // Inicializa el estado interno desde el prop (v-model)
    this.show = this.value;
  }

  // Sincroniza cuando el padre cambia el v-model
  @Watch("value")
  on_value_changed(val: boolean) {
    this.show = val;
  }

  // Reemite 'input' si el propio diálogo cambia 'show' (two-way binding correcto)
  @Watch("show")
  on_show_changed(val: boolean) {
    if (val !== this.value) {
      this.$emit("input", val);
    }
  }

  public select(kind: "llm" | "http") {
    this.$emit("select", kind);
    this.$emit("input", false); // Cierra el diálogo
  }

  public cancelar() {
    this.$emit("input", false);
    this.$emit("cancel");
  }
}
